export enum DiaryTypes {
    none = 'none',
    paperFax = 'paperFax',
    paperUpload = 'paperUpload',
}
